module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("A Luna’s Dark Past")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgment"
    }
  }, [_vm._v("Acknowledgment")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#the-beginning"
    }
  }, [_vm._v("The Beginning")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#something-strange"
    }
  }, [_vm._v("Something Strange")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#reality"
    }
  }, [_vm._v("Reality")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#full-moon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Full Moon")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#training",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Training")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#the-pack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Pack")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#explanation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Explanation")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#return-to-school",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Return to School")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#warrior-selection",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Warrior Selection")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#red-moon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Red Moon")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#investigation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Investigation")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#a-mothers-wish",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Mother’s Wish")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#truth",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Truth")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#spirit-world",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spirit World")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#the-plan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Plan")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#fertility-ritual",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fertility Ritual")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#panic",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Panic")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#talk",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Talk")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#alcides-training-has-begun",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alcide’s Training Has Begun")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#a-trip-down-memory-lane",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Trip Down Memory Lane")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#the-body",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Body")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#secrets",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Secrets")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#preparations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preparations")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#date-night",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Date Night")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#leaving",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leaving")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#cann-wood-forest",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cann Wood Forest")])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#cann-wood-forest-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cann Wood Forest")])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#cann-wood-forest-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cann Wood Forest")])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#heras-words",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hera’s Words")])]), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#relax",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Relax")])]), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#discussion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion")])]), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#information",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Information")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0